import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import {
  clientErrorTracker,
  useSoyuzLocales,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';
import { SpottyCat as SpottyCatComponent } from '@spotahome/ui-library';

import { useUserInfoContext } from '../../context/UserInfoContext';
import { useCitiesContext } from '../../context/CitiesContext';
import { emailSignupWithoutPassword } from '../../api/traditional-login-client';
import getGqlClient from '../../graphql/client';
import sendInviteEvent from '../../graphql/mutations/notifications';

const SpottyCat = ({ deviceType }) => {
  const { current: currentLocale } = useSoyuzLocales();
  const { cities } = useCitiesContext();
  const { userInfo, isUserLogged } = useUserInfoContext();
  const spottyCatContactUsExperiment = useSoyuzExperiment(
    'ShowSpottyCatContactUsDesktop'
  );

  const isSmartPhone = deviceType === 'smartphone';
  const showContactUs =
    !isSmartPhone &&
    spottyCatContactUsExperiment.get('behaviour') === 'variant';

  const handleSignupWithoutPass = async ({ email, marketingOptIn }) => {
    await emailSignupWithoutPassword({
      email,
      marketingOptIn,
      locale: currentLocale
    });
  };

  const handleInviteEvent = async payload => {
    try {
      sendInviteEvent(getGqlClient())({ input: payload });
    } catch (error) {
      clientErrorTracker.error({ error, source: 'SpottyCatModal' });
    }
  };

  return (
    <NoSSR>
      <SpottyCatComponent
        locale={currentLocale}
        user={userInfo}
        cities={cities}
        onSuccess={handleInviteEvent}
        onSignupWithoutPassword={!isUserLogged && handleSignupWithoutPass}
        isUserLogged={isUserLogged}
        isWhatsappShown={isSmartPhone}
        isContactUsShown={showContactUs}
      />
    </NoSSR>
  );
};

SpottyCat.propTypes = {
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default SpottyCat;
